function numberWithSpaces(x) {
  if (isNaN(x)) return '';
  var parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join('.');
}

export default {
  numberWithSpaces,
};
